/** Los lugares de quirófano de la clínica (p. ej. su propio quirófano y el
 * hospital donde opera). No van escritos en el código: los da de alta cada
 * clínica en Configuración (`lugares_direcciones`: nombre → dirección, que
 * además sale en los mensajes al paciente). Se piden una vez por sesión. */
import { useEffect, useState } from 'react';
import { api } from './api';

let cache = null;

export function lugaresDeAjustes(ajustes) {
  const mapa = ajustes?.lugares_direcciones;
  return mapa && typeof mapa === 'object' ? Object.keys(mapa).filter((k) => k.trim()) : [];
}

export async function cargarLugaresQuirofano() {
  if (cache) return cache;
  try {
    const r = await api.get('/api/settings');
    cache = lugaresDeAjustes(r.data);
  } catch {
    cache = [];
  }
  return cache;
}

/** Al guardar Configuración: la próxima pantalla los vuelve a pedir. */
export function olvidarLugaresQuirofano() {
  cache = null;
}

export function useLugaresQuirofano(actual) {
  const [lugares, setLugares] = useState(cache || []);
  useEffect(() => {
    let vivo = true;
    cargarLugaresQuirofano().then((l) => { if (vivo) setLugares(l); });
    return () => { vivo = false; };
  }, []);
  // Un lugar ya guardado que hoy no está en Configuración se sigue viendo.
  return actual && !lugares.includes(actual) ? [...lugares, actual] : lugares;
}
